import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { Container } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Header, Footer } from "~/components/blocks";
import {
  Margin,
  Title,
  Text,
  Button,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import * as S from "./styles";
import { scrollTo } from "~/utils/tools";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import { Creators as AccountActions } from "~/store/modules/account/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function VerifyNewEmail() {
  const mobile = isMobile();
  const dispatch = useDispatch();

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const Code = window.location.pathname.split("/")[2];

  const location = useLocation();

  const sending = useSelector((state) => state.account.newEmail.sending);
  const errorMessage = useSelector((state) => state.account.newEmail.message);
  const success = useSelector((state) => state.account.newEmail.success);
  const newEmail = useSelector((state) => state.account.newEmail.email);

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    scrollTo(700);
    const isCodeValido = (window.location.pathname.split("/")[2] || "").length > 40;
    if (isCodeValido && !success) {
      dispatch(
        AccountActions.sendConfirmEmailCode({
          Code: Code,
          confirm_email: true,
          url: url,
          origin: origin,
        })
      );
      dispatch(AuthenticationActions.purgeAuthentication());
    }

    if (success) {
      dispatch(AccountActions.setUpdateEmail());
    }
  }, [dispatch, Code, success, url, origin]);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Verificação Novo Email</title>
      </Helmet>

      <Header />

      <HeroBanner />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <Container>
          {sending ? (
            <Margin mt={mobile ? 6 : 12} mb={mobile ? 8 : 12}>
              <Loading />
            </Margin>
          ) : (
            <S.ContentHolder success={success}>
              <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
                {success && (
                  <Title as="2" level="4" levelDesktop="3">
                    E-mail alterado com sucesso!
                  </Title>
                )}
                {!success && errorMessage && (
                  <Title as="2" level="4" levelDesktop="3">
                    Desculpe. Não conseguimos realizar essa ação.
                  </Title>
                )}
              </Margin>
              <Margin mb={4}>
                <S.TextHolder>
                  {success ? (
                    <Text level="1">
                      Seu novo e-mail <strong>{newEmail}</strong> passará a
                      receber toda a comunicação Johnson’s. Faça login para
                      entrar na sua conta com seu novo e-mail.
                    </Text>
                  ) : (
                    <ErrorMessage inset>{errorMessage}</ErrorMessage>
                  )}
                </S.TextHolder>
              </Margin>
              <Margin mb={mobile ? 8 : 12}>
                <Button
                  onClick={() =>
                    history.push({
                      pathname: "/minha-conta",
                      search: location.search,
                    })
                  }
                  color="primary"
                  id="loginButtonVerify"
                >
                  Fazer login
                </Button>
              </Margin>
            </S.ContentHolder>
          )}
        </Container>
      </motion.div>

      <Footer />
    </>
  );
}
